<template>
	<div>
		<div class="x-stat">
			<a-row>
				<a-col :span="3">
					<a-statistic title="数量" :value="totalRow" />
				</a-col>
			</a-row>
		</div>

		<a-card :bordered="false">
			<div class="x-tool">
				<a-button type="primary" icon="plus" v-has="'/member/performerAdd'" @click="add">新增</a-button>
			</div>

			<a-table :rowKey="record => record.id" :columns="tableColumns" :loading="tableLoading"
				:dataSource="tableData" :pagination="false">
				<template slot="performer" slot-scope="record">
					<div class="performer">
						<div class="performer-right">
							<p class="first">
								<span class="nickname">{{ record.username }}</span>
							</p>
						</div>
					</div>
				</template>
				
				<span slot="sex" slot-scope="record">
					<span class="performer-right-detail" v-if="record.sex=='MALE'">男</span>
					<span class="performer-right-detail" v-else>女</span>
				</span>

				<span slot="google" slot-scope="record">
					<label v-if="record.googleSecret" class="normal">已绑定
						<a-divider type="vertical" />

						<a-popconfirm placement="topRight" title="你确定要解绑改用户吗?" @confirm="unbindGoogle(record.id)">
							<a href="#" v-has="'/performer/unBindGoogle'" class="error">解绑</a>
						</a-popconfirm>
					</label>

					<label v-else class="disabled">未绑定</label>
				</span>
				
				<span slot="action" slot-scope="record">
					<template v-if="record.isEnable == 'Y'">
						<a v-has="'/performer/performerResetPassword'" @click="resetPassword(record)">重置密码</a>
						<a-divider type="vertical" />
						<a v-has="'/member/performerUpdate'" @click="update(record)">修改</a>
						<a-divider type="vertical" />
						<a v-has="'/member/updateDisable'" @click="setDisabled(record.id, 'N')">禁用</a>
						<span v-if="!record.googleSecret">
							<a-divider type="vertical" />
							<a @click="bindGoogle(record.id)" v-has="'/performer/googleBind'">谷歌绑定</a>
						</span>
					</template>
					<template v-else>
						<a @click="setDisabled(record.id, 'Y')">启用</a>
					</template>
				</span>
			</a-table>
			
			<reset-password-modal ref="resetPasswordForm" :id="resetPasswdAdminId" :visible="resetPasswdVisible"
				:loading="resetPasswdLoading" @cancel="resetPasswdCancel" @ok="resetPasswdOk" />

			<Performer-form-modal ref="PerformerForm" :visible="PerformerFormVisible" :loading="PerformerFormLoading"
				:model="PerformerFormModel" @cancel="PerformerFormCancel" @ok="PerformerFormOk" />

			<div class="x-pagination">
				<a-pagination :pageSize="pageSize" v-model="pageIndex" :total="totalRow" @change="pageChange"
					:hideOnSinglePage="true" show-less-items />
			</div>
		</a-card>
		
		<a-modal :visible="googleVisible" title="绑定谷歌验证" @cancel="closeGoogleVisible" @ok="confirmBind">
			<div class="qrcode-box">
				<img class="qrcode" width="300px" height="300px" :src="qrcode" />
			</div>
		</a-modal>
	</div>
</template>

<script>
	import moment from "moment";
	import ResetPasswordModal from './ResetPassword';
	import PerformerFormModal from "@/pages/member/performer/PerformerForm.vue";
	import {
		performerList,
		performerAdd,
		performerUpdate,
		performerUpdateDisable,
		performerResetPassword,
		performerBindGoogleAuth,
		performerUnBindGoogleAuth,
		performerBindGoogleAuthPro,
	} from "@/api/member/performer.js";
	const tableColumns = [{
			title: '#',
			dataIndex: 'id'
		},
		{
			title: '演员名称',
			scopedSlots: {
				customRender: 'performer'
			}
		},
		{
			title: '性别',
			scopedSlots: {
				customRender: 'sex'
			}
		},
		{
			title: '登录名',
			dataIndex: 'loginName',
		},
		{
			title: '角色数量',
			dataIndex: 'roleNum',
		},
		{
			title: '谷歌验证',
			scopedSlots: {
				customRender: 'google'
			}
		},
		{
			title: '时间',
			dataIndex: 'created',
		},
		{
			title: '操作',
			scopedSlots: {
				customRender: 'action'
			}
		}
	];

	export default {
		components: {
			PerformerFormModal,
			ResetPasswordModal
		},
		data() {
			return {
				advanced: false,
				queryParams: {},
				totalRow: 0,
				tableColumns,
				tableData: [],
				tableLoading: false,
				pageSize: 20,
				pageIndex: 1,
				PerformerFormVisible: false,
				PerformerFormLoading: false,
				PerformerFormModel: null,
				activeTime: [],
				createTime: [],
				previewVisible: false,
				previewImage: '',
				resetPasswdAdminId: 0,
				resetPasswdVisible: false,
				resetPasswdLoading: false,
				googleVisible: false,
				qrcode: '',
				performerId: ''
			}
		},
		created() {
			this.fetchTableData();
		},
		methods: {
			fetchTableData() {
				this.tableLoading = true;
				this.queryParams.pageSize = this.pageSize;
				this.queryParams.page = this.pageIndex;
				performerList(this.queryParams).then(res => {
					this.totalRow = res.data.totalRow;
					this.tableData = res.data.recordList;

					this.tableLoading = false;
				});
			},
			pageChange(current) {
				this.pageIndex = current;
				this.fetchTableData();
			},
			toggleAdvanced() {
				this.advanced = !this.advanced;
			},
			onCreateTime(values) {
				this.queryParams.startCreateTime = moment(values[0]).unix();
				this.queryParams.endCreateTime = moment(values[1]).unix();
			},
			onActiveTime(values) {
				this.queryParams.startActiveTime = moment(values[0]).unix();
				this.queryParams.endActiveTime = moment(values[1]).unix();
			},
			add() {
				this.PerformerFormModel = null;
				this.PerformerFormVisible = true;
				this.$nextTick(() => {
					if (this.$refs.PerformerForm && this.$refs.PerformerForm.initForm) {
						this.$refs.PerformerForm.initForm();
					}
				});
			},
			update(record) {
				this.PerformerFormModel = {
					...record
				};
				this.PerformerFormVisible = true;
			},
			PerformerFormOk() {
				const modal = this.$refs.PerformerForm;
				if (!modal || !modal.$refs.adminForm) {
					return;
				}
				modal.$refs.adminForm.validate((valid) => {
					if (!valid) {
						return;
					}
					const values = { ...modal.form };
					if (values.id > 0) {
						delete values.loginPassword;
					}
					this.PerformerFormLoading = true;
					if (values.id > 0) {
						performerUpdate(values).then(() => {
							this.PerformerFormAfter('修改职业成功');
						}).catch(() => {
							this.PerformerFormLoading = false;
						});
					} else {
						performerAdd(values).then(() => {
							this.PerformerFormAfter('新增职业成功');
						}).catch(() => {
							this.PerformerFormLoading = false;
						});
					}
				});
			},
			PerformerFormCancel() {
				this.PerformerFormModel = null;
				this.PerformerFormVisible = false;
				if (this.$refs.PerformerForm && this.$refs.PerformerForm.initForm) {
					this.$refs.PerformerForm.initForm();
				}
			},
			PerformerFormAfter(message) {
				this.PerformerFormVisible = false;
				this.PerformerFormLoading = false;
				if (this.$refs.PerformerForm && this.$refs.PerformerForm.initForm) {
					this.$refs.PerformerForm.initForm();
				}
				this.fetchTableData();
				this.$message.success(message);
			},
			rest() {
				this.activeTime = [];
				this.createTime = [];
				this.queryParams = {}
			},
			bindGoogle(id) {
				let that = this;
				performerBindGoogleAuth(id).then(function(res) {
					if (res.code != 200) {
						this.$message.success(res.message);
						return false;
					}
					that.googleVisible = true;
					that.qrcode = res.data.qrcode;
					that.secret = res.data.secret;
					that.performerId = id;
				});
			},
			unbindGoogle(id) {
				performerUnBindGoogleAuth(id).then(() => {
					this.fetchTableData();
					this.$message.success('解绑成功');
				});
			},
			confirmBind() {
				let that = this;
				let params = {
					'id': that.performerId,
					'secret': that.secret
				}
				performerBindGoogleAuthPro(params).then(function() {
					that.$message.success('绑定成功');

					that.fetchTableData();
					that.googleVisible = false;
				});
			},
			closeGoogleVisible() {
				this.googleVisible = false;
			},
			resetPassword(record) {
				this.resetPasswdAdminId = record.id;
				this.resetPasswdVisible = true;
			},
			resetPasswdCancel() {
				this.resetPasswdVisible = false;
			},
			resetPasswdOk() {
				const modal = this.$refs.resetPasswordForm;
				if (!modal || !modal.$refs.adminForm) {
					return;
				}
				this.resetPasswdLoading = true;
				modal.$refs.adminForm.validate((valid) => {
					if (!valid) {
						this.resetPasswdLoading = false;
						return;
					}
					const values = { ...modal.form };
					performerResetPassword(values).then(() => {
						this.resetPasswdVisible = false;
						this.resetPasswdLoading = false;
						modal.form.password = '';
						if (modal.$refs.adminForm) {
							modal.$refs.adminForm.clearValidate();
						}
						this.$message.success('重置客服密码成功');
					}).catch(() => {
						this.resetPasswdLoading = false;
					});
				});
			},
			setDisabled(id, disable) {
				performerUpdateDisable(id, disable).then(() => {
					this.fetchTableData();
					if (disable == 'N') {
						this.$message.success(`客服:${id}，已禁用`);
					} else {
						this.$message.success(`客服:${id}，已启用`);
					}
				})
			},
		}
	}
</script>

<style lang="less" scoped>
	.depict {
		width: 540px;
		margin-top: 5px;
		line-height: 150%;
		font-size: 12px;
		color: #acacac;
	}

	.performer {
		display: flex;
		flex-direction: row;

		.performer-left {
			display: flex;
			flex-direction: column;
			margin-right: 5px;
			text-align: center;

			span {
				font-size: 12px;
			}
		}

		.performer-right {
			p.first {
				display: flex;
				flex-direction: row;
				margin: 0;

				.nickname {
					color: #686868;
					font-weight: bold;
				}
			}

			p.row {
				font-size: 12px;
				color: #acacac;
				margin: 0;
			}

			.performer-right-detail {
				margin-right: 5px;
			}
		}
	}

	.complex {
		display: flex;
		flex-direction: column;
	}
	
	.qrcode-box {
		.qrcode {
			display: flex;
			margin: auto;
		}
	}
</style>